export const checkNumber = (e) => {
    // prevent: "e", "=", ",", "-", "."
    if ([69, 187, 188, 189, 190].includes(e.keyCode)) {
        e.preventDefault();
    }
}